var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavIconPrototyping(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.3 85H96.6V28.3C96.6 23.7 92.9 20 88.3 20H83.3V23.3H88.3C91.1 23.3 93.3 25.5 93.3 28.3V85H61.7C61.1 85 60.5 85.4 60.2 85.9L59 88.3H41L39.8 85.9C39.5 85.4 39 85 38.3 85H8.3V28.3C8.3 25.5 10.5 23.3 13.3 23.3H71.6V20H13.3C8.7 20 5 23.7 5 28.3V85H1.7C0.7 85 0 85.7 0 86.7V91.7C0 96.3 3.7 100 8.3 100H91.6C96.2 100 99.9 96.3 99.9 91.7V86.7C100 85.7 99.3 85 98.3 85ZM96.7 91.7C96.7 94.5 94.5 96.7 91.7 96.7H8.3C5.5 96.7 3.3 94.5 3.3 91.7V88.4H37.3L38.5 90.8C38.8 91.4 39.4 91.7 40 91.7H60C60.6 91.7 61.2 91.3 61.5 90.8L62.7 88.4H96.7V91.7Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6996 26.7H13.2996C12.3996 26.7 11.5996 27.4 11.5996 28.4V80C11.5996 80.9 12.2996 81.7 13.2996 81.7H88.2996C89.1996 81.7 89.9996 81 89.9996 80V28.3C89.9996 27.4 89.2996 26.6 88.2996 26.6H79.9996V30H86.6996V78.3H81.6996V36.7H78.3996V78.4H74.9996V53.4H71.6996V78.4H68.3996V45H64.9996V78.3H61.6996V60H58.3996V78.3H54.9996V53.3H51.6996V78.3H48.3996V70H44.9996V78.3H41.6996V63.3H38.3996V78.3H34.9996V55H31.6996V78.3H28.3996V58.3H24.9996V78.3H21.6996V70H18.3996V78.3H14.9996V30H66.6996V26.7Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4002 5.9C79.3002 26 62.3002 41.7 41.7002 41.7V45C64.3002 45 82.9002 27.6 84.9002 5.5L88.9002 9.5L91.3002 7.1L84.6002 0.4C83.9002 -0.3 82.9002 -0.3 82.2002 0.4L75.5002 7.1L77.9002 9.5L81.4002 5.9Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4002 35H21.7002V38.3H38.4002V35Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4002 41.7H21.7002V45H38.4002V41.7Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0002 48.3H21.7002V51.6H25.0002V48.3Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0002 10H68.3002V6.7H71.7002V3.3H68.3002V0H65.0002V3.3H61.7002V6.7H65.0002V10Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3 16.7H56.7V13.3H60V10H56.7V6.70001H53.3V10H50V13.3H53.3V16.7Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5998 48.3H28.2998V51.6H31.5998V48.3Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3 48.3H35V51.6H38.3V48.3Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_304_3710"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconPrototyping);
export default __webpack_public_path__ + "static/media/Nav-Icon-Prototyping.e4cc73ae37265304f2e6331c06a551a4.svg";
export { ForwardRef as ReactComponent };